import {Component, Input, OnInit} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-calculation-version-export',
  templateUrl: './modal-calculation-version-export.component.html',
})
export class ModalCalculationVersionExportComponent extends ExcTranslation implements OnInit {
  @Input()
  data: any;

  constructor(
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
  }

  get selectedCount(): number {
    return ExcCoreModule.Array.GetAll(this.data.sheets, 'sheetSelected', true).length;
  }

  cancel(): void {
    this.modal.close();
  }

  save(): void {
    if (this.selectedCount > 0) {
      this.modal.action({exportSheets: JSON.stringify(
          ExcCoreModule.Array.GetAll(this.data.sheets, 'sheetSelected', true)
        )
      });
    }
  }
}
